<template>
  <div class=''>
    <SearchAreaSpectrum :search-holder='SearchHoder' @do-search='doSearch'></SearchAreaSpectrum>
    <div class=''>
      <div class='h-spectrum-treebox'>
      <LeftPanelNeList ref='spectrumNeList' :neArr='netype' :select='neClick' :keywords='keywords'></LeftPanelNeList>
      </div>
      <div class='h-spectrum-bacelltablebox'>
      <BSCellTable ref='bsCellTable' :ne='ne'></BSCellTable>
      </div>
    </div>
  </div>
</template>

<script>
import LeftPanelNeList from './LeftPanelNeList';
import SearchAreaSpectrum from './SearchAreaSpectrum.vue';
import BSCellTable from './BSCellTable';

export default {
  name: 'LeftPanelSpectrum',
  components: {
    BSCellTable,
    LeftPanelNeList,
    SearchAreaSpectrum
  },
  data() {
    return {
      SearchHoder: this.$t('Spectrum.ui_pt_searchNe'),
      netype: [
        10004, //'enodeb',
        10006, //'ibs',
        10007  //'bpdt'也叫ibs-B
      ],
      keywords: '',
      ne: ''
    };
  },
  methods: {
    doSearch(keywords) {
      this.keywords = keywords;
      /* if (keywords === '') {
        this.neDatas = this.primaryDatas;
        return;
      }
      const leftNeDatas = this.primaryDatas.filter(neData => (neData.nename.includes(keywords)));
      this.neDatas = leftNeDatas; */
      this.$refs.spectrumNeList.doSearch(keywords);
    },
    getNe(ne) {
      this.ne = ne.data;
      this.$refs.bsCellTable.getGridData();
    },
    neClick() {
      this.ne = this.$refs.spectrumNeList.getNe().data;
      this.$refs.bsCellTable.getGridData();
    },
  }
};
</script>

<style scoped>

</style>
